export default "__VITE_ASSET__Nc4wAucR__"